import { render, staticRenderFns } from "./NewCategoryModal.vue?vue&type=template&id=e411755a&"
import script from "./NewCategoryModal.vue?vue&type=script&lang=js&"
export * from "./NewCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports